"use client"

import { useState, useEffect } from "react"
import { db } from "../../firebase"
import { collection, getDocs } from "firebase/firestore"
import MobileNav from "../../components/MobileNav"
import ProductCard from "./ProductCard"
import ProductModal from "./ProductModal"
import "./Products.css"

export default function Products() {
  const [products, setProducts] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true)
      try {
        const productsCollection = collection(db, "products")
        const productSnapshot = await getDocs(productsCollection)
        const productList = productSnapshot.docs.map((doc) => doc.data())
        setProducts(productList)
      } catch (error) {
        console.error("Error fetching products:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchProducts()
  }, [])

  const closeModal = () => setSelectedProduct(null)

  return (
    <div className="products-page">
      <header className="light-header">
        <div className="container">
          <div className="logo">
            <a href="/" style={{ textDecoration: "none", fontWeight: "800", fontSize: "1.8rem", color: "#2c3e50" }}>
              Uniquely<span style={{ color: "#c0392b" }}>Sharp</span>
            </a>
          </div>
          <nav className="desktop-nav">
            <a href="/">Home</a>
            <a href="/events">Events</a>
            <a className="active" href="/products">
              Products
            </a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
          </nav>
          <MobileNav />
        </div>
      </header>

      <div
        className="hero-section"
        style={{ backgroundImage: `url('../assets_task_01jr6emfg8ftsafwn4204h0v9m_img_0.webp')` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Our Products</h1>
          <p>Explore our premium knives and cutting tools</p>
        </div>
      </div>

      <section className="product-list">
        <div className="container">
          <h2 className="section-title">All Products</h2>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading products...</p>
            </div>
          ) : (
            <div className="product-grid">
              {products.map((product, index) => (
                <ProductCard key={index} product={product} onClick={() => setSelectedProduct(product)} />
              ))}
            </div>
          )}
        </div>
      </section>

      {selectedProduct && <ProductModal product={selectedProduct} onClose={closeModal} />}

      <footer className="footer-section">
        <div className="footer-content">
          <div className="footer-column">
            <h3>
              Uniquely<span>Sharp</span>
            </h3>
            <p>Premium quality knives and cutting tools for professionals and enthusiasts.</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/g/15nBKAPV6a/?mibextid=wwXIfr" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/uniquely_sharp" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/events">Events</a>
              </li>
              <li>
                <a href="/products">Products</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <p>
            Bettendorf, Iowa
            </p>
            <p>
            UniquelySharpContact@gmail.com
              <br />
              (+1) 563-508-2716
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2025 <strong>Uniquely Sharp</strong>. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}
